import { AuthSchemaLineDTO } from './authSchemaLineDTO';
import { AuthSchema_TranslationDTO } from './authSchema_TranslationDTO';

export class AuthSchemaDTO {
  authSchemaId: number;

  auditTrailId: number;

  active: boolean;

  trans: AuthSchema_TranslationDTO[];

  lines?: AuthSchemaLineDTO[];

  bsEnabled?: boolean;

  bsId?: string;

  bsGroupId?: string;

  bsPlanId?: string;

  bsDisplayName?: string;

  bsUniqueName?: string;

  constructor() {
    this.authSchemaId = 0;
    this.auditTrailId = 0;
    this.trans = [];
    this.active = false;
  }
}
